interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <div className="mt-10 flex items-center justify-center gap-2">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className="inline-flex items-center gap-1 h-9 px-3.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-700 whitespace-nowrap transition-colors hover:border-accent-300 hover:text-accent-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300 disabled:hover:text-foreground-700 cursor-pointer"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          className={`w-9 h-9 rounded-md text-sm transition-colors cursor-pointer ${
            item === page
              ? "bg-primary-500 text-background-50"
              : "border border-background-300 bg-background-50 text-foreground-700 hover:border-accent-300 hover:text-accent-600"
          }`}
        >
          {item}
        </button>
      ))}

      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        className="inline-flex items-center gap-1 h-9 px-3.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-700 whitespace-nowrap transition-colors hover:border-accent-300 hover:text-accent-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300 disabled:hover:text-foreground-700 cursor-pointer"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </div>
  );
}